var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfficeInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.307,
    height: 21.637,
    viewBox: "0 0 23.307 21.637",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "office_information") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#00a0e9;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M26,37h1.665v3.33H26Z",
    transform: "translate(-15.179 -23.453)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.992,41.107H14.486v1.249a.835.835,0,0,1-.832.832H11.989a.835.835,0,0,1-.832-.832V41.107H4.081A3.75,3.75,0,0,1,2,40.47v4.382a2.917,2.917,0,0,0,2.913,2.913H17.557A4.981,4.981,0,0,1,15.992,41.107ZM3.665,45.269a.416.416,0,0,1-.832,0V42.355a.416.416,0,0,1,.832,0Z",
    transform: "translate(-1.167 -26.129)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M40.262,38a4.162,4.162,0,1,0,4.062,4.162A4.162,4.162,0,0,0,40.262,38Zm.316,6.659a.416.416,0,1,1-.832,0V40.912a.416.416,0,0,1,.832,0Zm0-4.994a.416.416,0,0,1-.832,0v-.416a.416.416,0,1,1,.832,0Z",
    transform: "translate(-21.017 -24.686)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.393,3.536H16.231V2.122A2.335,2.335,0,0,0,13.734,0H9.572a2.335,2.335,0,0,0-2.5,2.122V3.536H2.913A2.724,2.724,0,0,0,0,6.012V11.67a2.721,2.721,0,0,0,2.913,2.475H9.989V13.084a.78.78,0,0,1,.832-.707h1.665a.78.78,0,0,1,.832.707v1.061h2.114a5.607,5.607,0,0,1,6.751-.53,2.336,2.336,0,0,0,1.124-1.945V6.012A2.724,2.724,0,0,0,20.393,3.536ZM7.908,2.122A1.555,1.555,0,0,1,9.572.707h4.162A1.555,1.555,0,0,1,15.4,2.122V3.536H7.908ZM3.746,4.951H2.5A.389.389,0,0,1,2.081,4.6.389.389,0,0,1,2.5,4.244H3.746a.389.389,0,0,1,.416.354A.389.389,0,0,1,3.746,4.951Zm16.231,0H5.41A.389.389,0,0,1,4.994,4.6a.389.389,0,0,1,.416-.354H19.977a.389.389,0,0,1,.416.354A.389.389,0,0,1,19.977,4.951Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeInformation);
export default __webpack_public_path__ + "static/media/office_information.5bee1b7d665fd4489b84d1755ee95d74.svg";
export { ForwardRef as ReactComponent };